import { Component, Input } from '@angular/core';

@Component({
    selector: 'remitter-button',
    templateUrl: './remitter-button.component.html',
    styleUrls: ['./remitter-button.component.css'],
})
export class RemitterButtonComponent {
    @Input() label?: string;
    @Input() icon?: string;
    @Input() styleClass?: string;
    @Input() size?: string;
    @Input() severity?: string;
    @Input() disabled?: boolean;

    getStyleClass() {
        let newStyleClass: { [key: string]: boolean } = {
            'rem-btn': true,
            'rem-btn-severity': !this.disabled,
            'rem-btn-lg': this.size === 'lg',
            'rem-btn-primary': !this.severity || this.severity === 'primary',
            'rem-btn-outline': !this.disabled && this.severity === 'outline',
            'rem-btn-secondary': this.severity === 'secondary',
            'rem-btn-info': this.severity === 'info',
            'rem-btn-disabled': this.disabled === true,
        };

        if (this.styleClass) {
            newStyleClass[this.styleClass] = true;
        }

        return newStyleClass;
    }
}
